import { Extension } from '@tiptap/core'
import {
  InputRule
} from 'prosemirror-inputrules'

export const leftArrow = new InputRule(/<--$/, '<—')
export const rightArrow = new InputRule(/-->$/, '—>')

export const Typography = Extension.create({
  name: 'typography',

  addInputRules () {
    return [
      leftArrow,
      rightArrow
    ]
  }
})
